import React, { useState } from "react";
import * as API from "../../framework/API/api";
import { EditPageHeader } from "../../components/EditPageHeader";
import { useTranslation } from "../../locale/useTranslation";
import { LOCALSTORAGE_KEY, TOAST_TYPES } from "../../framework/constant/constant";
import ToastNotification from "../../components/ToastNotification";
import BossDialog from "../../components/BossDialog";
import { utility } from "../../framework/utility/utilityProvider";

const ContractAttachmentForm = (props) => {
    const lang = useTranslation();
    const { onSaveData, cancelEdit } = props;
    let user = utility.getValue(LOCALSTORAGE_KEY.userData);

    const [dataItem, setDataItem] = useState({
        Description: "",
        Remarks: "",
        filename: "",
        url: ""
    });
    const [selectedFile, setSelectedFile] = useState(null);

    const onChange = (e) => {
        const { name, value } = e.target;
        setDataItem({ ...dataItem, [name]: value });
    };

    const onFileChange = (e) => {
        const files = Array.from(e.target.files);
        if (files.length === 0) return;
        const file = files[0];

        setSelectedFile(file);
        setDataItem((prev) => ({ ...prev, filename: file.name }));
        e.target.value = '';
    };

    const isValid = () => {
        if (dataItem.Description == '' || dataItem.Description == undefined) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_description_error_message });
            return false;
        }
        if (!selectedFile && !dataItem.url) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_a_file_label });
            return false;
        }
        return true;
    };

    const handleSubmit = async (e) => {
        if (e && e.preventDefault) e.preventDefault();
        if (!isValid()) return;

        const attachment = {
            Description: dataItem.Description,
            Remarks: dataItem.Remarks,
            filename: dataItem.filename,
            url: dataItem.url,
            file: selectedFile,
            isUploaded: false,
            AddOn: new Date().getTime(),
            AddBy: {_id : user?._id, Name: user?.name}
        };

        onSaveData(attachment);
    };

    return (
        <BossDialog title={lang.add_attachment_label} onClose={cancelEdit} width="460px" height="auto">
            <div className="p-2">
                <EditPageHeader showTitle={false} onSubmit={handleSubmit} onCancel={cancelEdit} />
                <div className="row mt-2">
                    <div className="col-12 form-group">
                        <label htmlFor="Description">{lang.description_label} *</label>
                        <input
                            type="text"
                            name="Description"
                            placeholder="Enter Description"
                            className="form-control form-control-sm"
                            value={dataItem.Description}
                            onChange={onChange}
                        />
                    </div>
                </div>
                <div className="row mt-1">
                    <div className="col-12 form-group">
                        <label htmlFor="Remarks">{lang.remarks_label}</label>
                        <input
                            type="text"
                            name="Remarks"
                            placeholder="Enter Remarks"
                            className="form-control form-control-sm"
                            value={dataItem.Remarks}
                            onChange={onChange}
                        />
                    </div>
                </div>
                <div className="row mt-1 align-items-center">
                    <div className="col-12 form-group mb-0">
                        <label htmlFor="Media">{lang.file_label} *</label>
                        <div className="input-group">
                            <input
                                name="filename"
                                className="form-control form-control-sm"
                                type="text"
                                placeholder="Select file..."
                                value={dataItem.filename}
                                readOnly
                            />
                            <button
                                type="button"
                                className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
                                style={{ height: "32px", margin: "0 0 0 3px" }}
                                onClick={() => document.getElementById("attachmentFileInput").click()}
                            >
                                <i className="fa fa-plus" aria-hidden="true"></i>
                            </button>
                            <input
                                type="file"
                                id="attachmentFileInput"
                                name="attachmentFile"
                                onChange={onFileChange}
                                style={{ display: "none" }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </BossDialog>
    );
};

export default ContractAttachmentForm;
